import React from 'react';

const PostError = () => {
  return (
    <div name="post-error">
      <div className="article">
        <aside className="labels">
          <span className="label">
            <i style={{backgroundColor:'red'}}></i>
            Erro
          </span>
        </aside>
        <h2>Não foi possível carregar o feed</h2>
        <div className="post-body">
          <div>
              Não foi possível recuperar o feed do seu usuário, clique no botão abaixo para 
              recarregar os posts de atualizações.
              <br/><br/>
              Desculpe pelo ocorrido :(
          </div>
        </div>  
      </div>
    </div>
  )
} 

export default PostError;